<template>
    <v-select :multiple="multiple" :label="label" :items="all_tenants" item-value="ID" item-text="Tenant" v-model="vModel" :rules="rules" prepend-icon="fas fa-building"></v-select>
</template>
<script>
export default {
    props: {
        value: {},
        label: { type: String, default: 'Tenant' },
        rules: { type: Array, default: () => [] },
        withAll: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
    },
    computed: {
        vModel: {
            get() {
                if (this.$props.multiple && !Array.isArray(this.value)) {
                    return [this.value]
                }
    
                return this.value
            },
            set(v) {
                this.$emit('input', v);
            }
        },
    },
}
</script>